import React from 'react'
import Collection from '../common/collection'

function CollectionG({ props }) {
  return (
    <Collection
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/6.+mano12.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/6.+mano31.jpg',
      ]}
      alt="Mano"
    />
  )
}


export default CollectionG
